/**
 * Resolve the marketing-site URL for "back to marketing" links and the
 * logged-out app-root redirect.
 *
 * Order of preference:
 *   1. config.json `marketing_url` (stored in localStorage at startup).
 *   2. Derive from the current portal host: portal.<domain> -> <domain>
 *      (works for both dev portal.xrathus.d4l.cloud and prod portal.xrathus.com).
 *   3. Last-resort hard-coded production marketing site.
 *
 * Guards against a missing/empty value or the literal string "undefined"
 * (which localStorage.setItem stores when handed an undefined value) so the
 * redirect never resolves to a bogus path like "/undefined".
 *
 * @return {string} absolute marketing-site URL
 */
export function getMarketingUrl() {
    const stored = localStorage.getItem('marketing_url');
    if (stored && stored !== 'undefined') {
        return stored;
    }
    const origin = window.location.origin;
    if (origin.indexOf('://portal.') !== -1) {
        return origin.replace('://portal.', '://');
    }
    return 'https://xrathus.com';
}
